import { render, staticRenderFns } from "./CurrencySelect.vue?vue&type=template&id=bddf0cf8"
import script from "./CurrencySelect.ts?vue&type=script&lang=ts&external"
export * from "./CurrencySelect.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports